import styled from "@emotion/styled";
import { dateWidth, nameWidth, signatureWidth } from "@newComponents/common/Viewer/EConsentDocsPdfViewerPageMarkerZone";
import { DocumentMarker } from "@newHooks/context/document/documentMarker.context";
import { EConsentMarkerProps } from "./EConsentMarker";
import { DocumentSignerAttrType } from "@maven-rest/docs/DocumentSign.dto";

export function TemplateMarker(props: EConsentMarkerProps & { templateChildren: DocumentMarker[]; isModeDragging: boolean }) {
  const left = Math.min(...props.templateChildren.map((el) => el.x ?? 99999));
  const right = Math.max(...props.templateChildren.map((el) => el.x ?? -99999));
  const rightestElement = props.templateChildren.find((el) => el.x === right);
  const rightestElementWidth = rightestElement
    ? rightestElement.attr === DocumentSignerAttrType.Name
      ? nameWidth
      : rightestElement.attr === DocumentSignerAttrType.Signature
      ? signatureWidth
      : dateWidth
    : 0;

  const width = right - left + rightestElementWidth + 12;

  return (
    <StyledTemplateMarker {...props} width={width} isModeDragging={props.isModeDragging}>
      {props.children}
    </StyledTemplateMarker>
  );
}

const StyledTemplateMarker = styled("div")<EConsentMarkerProps & { width: number; isModeDragging: boolean }>((props) => ({
  userSelect: "none",
  boxSizing: "border-box",
  display: "inline-block",
  position: "absolute",
  width: `${props.width}px`,
  height: "36px",
  top: props.top,
  left: props.left,
  transform: "translateY(-50%)",
  borderRadius: "2px",
  outline: props.isModeSigning || props.isModeDragging ? "none" : "1px dashed #2EABD8",

  border: "none",

  backgroundColor: "transparent",

  textIndent: "0",
  zIndex: -1,

  cursor: "pointer",

  "& > div:nth-of-type(1)": {
    zIndex: 3,
  },
  "& > div:nth-of-type(2)": {
    zIndex: 2,
  },
  "& > div:nth-of-type(3)": {
    zIndex: 1,
  },

  "&:hover": {
    //NOTE: marker hover 시, UnlinkButton이 보임
    "& > span": {
      opacity: props.isModeDragging ? 0 : 1,
    },
  },
}));
